'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBoxContainer = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _device = require('redux/modules/device');

var _Sagas = require('decorators/Sagas');

var _selectors = require('redux/saga/selectors');

var _decorator = require('helpers/decorator');

var _filterSets = require('constants/filter-sets');

var _search = require('../search.saga');

var _Search = require('../Search.reducer');

var _SearchBox = require('./SearchBox.reducer');

var _SearchBox2 = require('./SearchBox');

var _Search2 = require('../Search.constants');

var _SearchBox3 = require('./SearchBox.constants');

var _SearchBox4 = require('./SearchBox.saga');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    openPanel: (0, _SearchBox.selectOpenPanel)(state),
    mediaQueryLg: (0, _device.selectMediaState)(state).lg,
    isMapView: (0, _Search.selectMapView)(state),
    keywordText: (0, _SearchBox.selectKeywordSearchBoxText)(state),
    locationText: (0, _SearchBox.selectLocationSearchBoxText)(state),
    selectedVertical: (0, _selectors.filterSetFilterValue)(state, _filterSets.SEARCH, _Search2.FILTER_NAMES.VERTICAL),
    isHidden: !(0, _device.selectIsClient)(state) // Hide the searchbox until the screen size is set from client to avoid visible repositioning while page loads
  };
};

var mapDispatchToProps = {
  onPanelClose: _SearchBox.closeOpenPanel,
  onToggleMapView: _Search.toggleMapView,
  onClickCollapsedSearchBar: _SearchBox.setOpenPanel.bind(null, _SearchBox3.PANEL_NAMES.location)
};

var SearchBoxContainer = exports.SearchBoxContainer = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _reactIntl.injectIntl, (0, _Sagas.withSagas)({
  load: _search.initializeUserLocationForSearch,
  watch: _SearchBox4.watchSearchBoxSagas
}))(_SearchBox2.SearchBox);